<div class="card_title loading" [style.width]="width">

</div>
